import { EmptyState, EmptyStateBody, Icon, PageSection } from '@patternfly/react-core';
import { ExclamationTriangleIcon } from '@patternfly/react-icons';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';


const WarningIcon: React.FunctionComponent = () => (
  <Icon status="warning" isInline>
    <ExclamationTriangleIcon />
  </Icon>
);

const NotFound: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const location = useLocation();
  return (
    <PageSection hasBodyWrapper={false} isFilled={true} isWidthLimited={false} padding={{ default: 'noPadding' }} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <EmptyState
        titleText={t('notFound.title', '404 Page not found')} variant="full"
        icon={WarningIcon}
      >
        <EmptyStateBody>
          {t('notFound.description', "We didn't find a page that matches the address you navigated to.")}
          <br />
          <code style={{ marginTop: '1rem', display: 'inline-block' }}>
            {location.pathname}
          </code>
        </EmptyStateBody>
      </EmptyState>
    </PageSection>
  );
};

export { NotFound };
